import { Box, Container } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { usePageFooter } from '#src/providers/page-layout-provider';

export function PageFooter() {
  const { footerRef, footerMode } = usePageFooter();
  const [hasContent, setHasContent] = useState(false);
  const isFixed = footerMode === 'fixed';

  useEffect(() => {
    const checkContent = () => {
      if (footerRef.current) {
        const hasChildren = footerRef.current.children.length > 0;
        setHasContent(hasChildren);
      } else {
        setHasContent(false);
      }
    };

    // Check after a microtask to ensure ref is attached and portal content may have rendered
    Promise.resolve().then(checkContent);

    // Set up MutationObserver to watch for changes
    const observer = new MutationObserver(checkContent);

    if (footerRef.current) {
      observer.observe(footerRef.current, {
        childList: true,
        subtree: true,
      });
    }

    return () => {
      observer.disconnect();
    };
  }, [footerRef]);

  return (
    <Box
      position={isFixed ? 'relative' : 'sticky'}
      bottom={isFixed ? undefined : 0}
      zIndex={10}
      bg="white"
      shadow="sm"
      borderTopWidth="1px"
      borderColor="gray.200"
      mt={isFixed ? 0 : 'auto'}
      flexShrink={isFixed ? 0 : undefined}
      width="100%"
      display={hasContent ? 'block' : 'none'}
    >
      <Container maxW="container.xl" px={4} py={3}>
        {/* Portal target for page footer content */}
        <Box ref={footerRef} width="100%" />
      </Container>
    </Box>
  );
}
